var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStandard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.1 27.4",
    style: {
      enableBackground: "new 0 0 200.1 27.4"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,0.1h6.2l6.7,27.3h-5.6L14.4,0.1z M5.5,0.1h6.1l6.7,27.3h-5.5L5.5,0.1z M9.5,27.3H0L2.5,2.6L9.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9,0.1v4.7h-7.2v10.9h6.5v4.7h-6.5v2.3h7.2v4.7H30.5V0.1H42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,0.1h15.2v4.7h-5v22.6h-5.2V4.8h-5V0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,0.1C75.4,0.1,80,4.6,80,10.2c0,3.1-1.5,6-3.9,8l3.9,9.2h-5.2l-3.1-7.2c-0.7,0.1-1.3,0.2-2,0.2v7h-5.2V0.1H69.8z  M74.8,10.2c0-3-2.3-5.5-5.1-5.5v10.9C72.6,15.7,74.8,13.2,74.8,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,13.7c0,7.6-5.8,13.7-12.9,13.7s-12.9-6.2-12.9-13.7C82.8,6.5,88.3,0,95.8,0C102.9,0,108.7,6.2,108.7,13.7z  M95.8,22.7c4.3,0,7.8-4.1,7.8-9s-3.5-9-7.8-9c-4.8,0-7.8,4.7-7.8,9C88,18.7,91.5,22.7,95.8,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,0.1c5.6,0,10.1,4.5,10.1,10.1s-4.5,10.1-10.1,10.1l0,0v7h-5.1V0.1H117z M122.1,10.2c0-3-2.3-5.5-5.1-5.5v10.9 C119.8,15.7,122.1,13.2,122.1,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2,13.7c0,7.6-5.8,13.7-12.9,13.7c-7.1,0-12.9-6.2-12.9-13.7c0-7.2,5.5-13.7,12.9-13.7C150.4,0,156.2,6.2,156.2,13.7z  M143.3,22.7c4.3,0,7.8-4.1,7.8-9s-3.5-9-7.8-9c-4.8,0-7.8,4.7-7.8,9C135.5,18.7,139,22.7,143.3,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,22.7v4.7h-7.1v-4.7H172.8z M164.5,0.1v27.3h-5.1V0.1H164.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,0.1v27.3H176V0.1H181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2,27.3c-3.3,0-6.4-1.6-7.4-4.5l4.8-2.1c0,1.1,1.2,1.9,2.6,1.9s2.6-0.9,2.6-1.9c0-2.5-10.4-4.3-10.4-12.6 c0-4.7,3.8-8,8.5-8c3.9,0,7.1,3,7.1,6.6c0,3-2.2,5.6-5.1,6.3L193,8.6c1.1,0,2-0.8,2-1.9s-0.8-2-1.9-2H193c-1.8,0-3.3,1.5-3.3,3.3 l0,0c0,5.3,10.4,5.6,10.4,12.6C200,25,196.2,27.3,192.2,27.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStandard);
export default ForwardRef;